import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React, { createContext, useContext } from 'react';
var CommunicationContext = /*#__PURE__*/createContext({
  resendMessage: function resendMessage() {},
  sendMessage: function sendMessage() {},
  sendImgMessage: function sendImgMessage() {},
  sendFileMessage: function sendFileMessage() {},
  resendImageMessage: function resendImageMessage() {}
});
export var CommunicationProvider = function CommunicationProvider(_ref) {
  var children = _ref.children,
    value = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CommunicationContext.Provider, {
    value: value
  }, children);
};
export var useCommunicationContext = function useCommunicationContext() {
  return useContext(CommunicationContext);
};